import { usePaginatedApi } from "../../../swr/useApi";
import { adminProductRequestsService } from "../../api_client";
import type { ProductRequestDto, ProductRequestQueryDto } from "../../../api";

export function useAdminUserProductRequests(query: Pick<ProductRequestQueryDto, "userId" | "page" | "pageSize">) {
  return usePaginatedApi<ProductRequestDto, ProductRequestQueryDto>({
    key: "admin-user-product-requests",
    serviceMethod: (q) => adminProductRequestsService.adminGetAllProductRequests(q),
    query,
  });
}
